module.exports = __webpack_public_path__ + "static/media/wristband-black.22589e73.png";